// -
import React from 'react';
import {connect} from 'react-redux'
import {FixedDropDownButton, modal, Loader, AbstractReactComponent} from 'mc/lib';
import * as subjektFormatter from "mc/lib/utils/subjektFormatter";
import ApiObjectSuggestField from 'mc/lib/field/ApiObjectSuggestField';
import {COMPONENT_CHILDREN} from 'mc/lib/Utils2';

import SubjektApi from "mc/lib/api/gen/subjekty/SubjektApi";


class SubjektField extends AbstractReactComponent {

    constructor(props) {
        super(props);
    }

    static propTypes = {
        kodRole: React.PropTypes.string.isRequired, // kód role subjektu v shared
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
    };

    static defaultProps = {
        showZastupce: true,
        showSubjektPripadData: false,
        apiRequestDelay: 400,
        alwaysShowOdpovednaOsoba: false,
        disableOdpovednaOsoba: false,
    };

    /**
     * Volani metody pro fulltextove vyheldavani.
     */
    handleFilterSuggestions = (value) => {
        const {kodRole} = this.props;
        return SubjektApi.findSubjekty(value, kodRole, null, 200);
    };


    /**
     * Renderování položky našeptávače.
     * @param subjekt subjekt
     * @return {XML}
     */
    renderSubjekt = (subjekt) => {
        let email = "";
        if (subjekt.email) {
            email = ", " + subjekt.email.kontakt;
        }
        return <span>{subjektFormatter.getUplnyNazev(subjekt) + email}</span>
    };

    render() {
        const {addonsAfter, disabled, ...other} = this.props;

        return (
            <ApiObjectSuggestField
                minCharsForFilter={3}
                getItemValue={(i, itemValueAttrName) => i ? subjektFormatter.getUplnyNazev(i) : ""}
                placeholder="Vyhledat subjekt..."
                filterSuggestions={this.handleFilterSuggestions}
                renderSuggestion={this.renderSubjekt}
                addonsAfter={addonsAfter}
                disabled={disabled}
                {...other}
            />
        )
    }
}

export default connect()(SubjektField);
